import * as React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Grid": Grid, "@mui/material/Card": Card, "@mui/material/CardHeader": CardHeader, "@mui/material/ListItemText": ListItemText, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/Checkbox": Checkbox, "@mui/material/Button": Button, "@mui/material/Divider": Divider, "@mui/material/Stack": Stack, "@mui/material/MenuItem": MenuItem, "@mui/material/MenuList": MenuList, "@mui/icons-material/CheckBox": CheckBoxIcon, "@mui/icons-material/CheckBoxOutlineBlank": CheckBoxOutlineBlankIcon } } });
export default ClientProvider;
